import { unflatten } from 'flat';
import * as React from 'react';
import { Content } from '../../interfaces';
import { applyBrandingToContent } from '../../utilities/branding';
import toggleAEMSibling from '../../utilities/toggleAEM';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
import ContentContext from './Context';

const App = ({ content, errors }: any) => {
  toggleAEMSibling(false);

  const getContentValue = (): Content => {
    if (!content) { return {} as Content; }
    // Decode AEM content, apply date-based branding flag, then parse.
    const decoded = decodeURIComponent(content);
    const branded = applyBrandingToContent(decoded);
    return unflatten(JSON.parse(branded)) as Content;
  };

  return (
    <div className="pension-pot-calculator">
      <ContentContext.Provider value={getContentValue()}>
        <SectionWrapper errors={errors} />
      </ContentContext.Provider>
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.tsx